import { render, staticRenderFns } from "./DialogOrderDetail.vue?vue&type=template&id=551ffb46&scoped=true&"
import script from "./DialogOrderDetail.vue?vue&type=script&lang=js&"
export * from "./DialogOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ffb46",
  null
  
)

export default component.exports